import { ReactNode } from 'react';
import SectionHeader from '../../../components/SectionHeader';
import { RiLoader3Fill } from '@remixicon/react';
import { useLanguage } from '../../../contexts/language';

const DashboardPageWrapper = ({
  title,
  subtitle,
  children,
  isLoading,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  children: ReactNode;
  isLoading: boolean;
}) => {
  const { t } = useLanguage();
  return (
    <div className="grid grid-rows-[auto_1fr] h-full">
      <SectionHeader className="mb-4">
        <div className="grid grid-cols-[1fr_auto] items-center">
          <div className="flex gap-4 items-end">
            <div>
              <h1 className="text-4xl">{title}</h1>
              {subtitle && <h3 className="text-base mt-2">{subtitle}</h3>}
            </div>
            {isLoading && <RiLoader3Fill className="animate-spin size-8" />}
          </div>
          <img
            title={t('content.drcdg-title')}
            className="h-[82px] hidden md:block"
            src="/images/drcdg_std_colour.png"
          />
        </div>
      </SectionHeader>
      <div className="min-h-0 overflow-auto pb-4">
        <div className="main-content">
          <div className="grid grid-rows-[min-content_1fr] h-full gap-4">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPageWrapper;
